import { AppData } from '../types/apollo/GetTranslations'
import { Translations } from '../types/i18n'
import { flattenTranslations } from './flattenSitecoreTranslations'
import fallbackTranslationsObject from './lp-en-sitecore.json'

export const fallbackTranslations: Translations = flattenTranslations(
  fallbackTranslationsObject.data.ftbToolV2 as AppData,
)
